import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    root: {
        marginTop: '110px',
        marginBottom: '30px',
    }
    
}))